















































import mixins from 'vue-typed-mixins'
import DraftElement from '@/builder/sections/mixins/DraftElement'
import CCalendarServicePanel from '@/builder/sections/section/calendars/components/CCalendarServicePanel.vue'
import CCalendarCategoryPanel from '@/builder/sections/section/calendars/components/CCalendarCategoryPanel.vue'
import CCalendarSearchPreview from '@/builder/sections/section/calendars/components/CCalendarSearchPreview.vue'

export default mixins(DraftElement).extend({
  name: 'CCalendarServicesPreview',
  components: {
    CCalendarCategoryPanel,
    CCalendarServicePanel,
    CCalendarSearchPreview
  },
  props: {
    selectServicesTitle: {
      type: String,
      default: ''
    },
    expandCollapseServicePanels: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    classForViewRound: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    }
  }
})
